import { useQuery } from '@tanstack/react-query'
import { getSchemaCatalogue } from '@/services/api/schemaCatalogue'

export function useSchemaCatalogue() {
  return useQuery({
    queryKey: ['schema-catalogue'],
    queryFn: getSchemaCatalogue,
    staleTime: Infinity,
  })
}
